module.exports = __webpack_public_path__ + "img/service1.70632658.png";